(function(){
  // Gorgias's chat UI is rendered inside SAME-ORIGIN iframes nested inside
  // #gorgias-chat-container. From the parent we attach click listeners to
  // each iframe's contentDocument. The patcher does two things:
  //   1) "View cart" button + /#/cart anchor → navigate TOP window to /cart.
  //   2) "add X to the cart" aria-labelled + "Add to cart" drawer button →
  //      look up X in window.SHOPIFY_CATALOGUE and call window.plAddToCart
  //      to put it in the React cart (the gold drawer + /cart page).

  function normalizeName(s){ return (s||'').toLowerCase().replace(/[\s\-_+]/g, ''); }
  function findProduct(name){
    var cat = window.SHOPIFY_CATALOGUE || [];
    if (!cat.length) return null;
    var target = normalizeName(name);
    if (!target) return null;
    for (var i = 0; i < cat.length; i++) { if (normalizeName(cat[i].name) === target) return cat[i]; }
    for (var j = 0; j < cat.length; j++) {
      var pn = normalizeName(cat[j].name);
      if (pn && (pn.indexOf(target) >= 0 || target.indexOf(pn) >= 0)) return cat[j];
    }
    return null;
  }
  function buildCartProduct(p){
    var cp = {};
    for (var k in p) cp[k] = p[k];
    if (Array.isArray(p.variants) && p.variants.length) {
      var v = p.variants[0];
      cp.dose = v.dose;
      cp.price = v.price;
      cp.variantId = v.variantId;
      if (v.image) cp.image = v.image;
    } else {
      cp.variantId = p.defaultVariantId;
    }
    return cp;
  }
  function addProductToCart(name){
    var p = findProduct(name);
    if (!p) { console.warn('[pl-chat-patch] no catalogue match for:', name); return false; }
    var cp = buildCartProduct(p);
    // Prefer the SPA's addToCart (exposed on window). silent=true so we
    // don't pop the drawer over the chat the user is using.
    if (typeof window.top.plAddToCart === 'function') {
      window.top.plAddToCart(cp, 1, false, true);
      return true;
    }
    // Fallback: write directly to localStorage (which the SPA reads on mount).
    // Then reload the parent so React state picks it up.
    try {
      var win = window.top || window;
      var raw = win.localStorage.getItem('pl_cart_v1');
      var arr = raw ? JSON.parse(raw) : [];
      var existing = null;
      for (var i = 0; i < arr.length; i++) { if (arr[i].product && arr[i].product.id === cp.id) { existing = arr[i]; break; } }
      if (existing) existing.qty += 1; else arr.push({ product: cp, qty: 1 });
      win.localStorage.setItem('pl_cart_v1', JSON.stringify(arr));
      win.location.href = '/cart';
      return true;
    } catch(e) { return false; }
  }
  function productNameFromDrawer(btn){
    // The drawer that holds the in-detail "Add to cart" button typically
    // has a heading + Q&A buttons like "How is GHK-Cu supplied?". Try the
    // heading first; if missing, sniff the Q&A buttons for a product name.
    var doc = btn.ownerDocument;
    var heading = doc.querySelector('h1, h2, h3, h4');
    if (heading && heading.textContent.trim()) return heading.textContent.trim();
    var qbtns = doc.querySelectorAll('button');
    for (var i = 0; i < qbtns.length; i++) {
      var t = (qbtns[i].textContent || '').trim();
      var m = t.match(/(?:how|what|why|when|are|is|does|do)\s+.*?(?:of|for|about|to|in|on|is)\s+([A-Z][\w\-\s+]*?)\??$/i);
      if (m) return m[1].trim();
    }
    return null;
  }
  function handleClick(e){
    var el = e.target;
    var btn = null;
    for (var i = 0; i < 8 && el; i++) {
      if ((el.tagName && /^(BUTTON|A)$/.test(el.tagName)) || (el.getAttribute && el.getAttribute('role') === 'button')) {
        btn = el; break;
      }
      el = el.parentElement;
    }
    if (!btn) return;
    var text = (btn.textContent || '').trim();
    var aria = (btn.getAttribute && btn.getAttribute('aria-label')) || '';
    var href = btn.getAttribute && btn.getAttribute('href') || '';

    // --- Navigate-to-cart matchers ---
    // The carousel "View cart" header button.
    if (/^view\s*(your\s*)?cart$/i.test(aria) || /^view\s*(your\s*)?cart$/i.test(text) || /^cart$/i.test(text)) {
      try { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); } catch(_){}
      (window.top || window).location.href = '/cart';
      return;
    }
    // Anchor where href OR rendered text contains /cart (AI-generated link).
    if (btn.tagName === 'A' && (/\/cart(\/|$|\?|#)/i.test(href) || /\/cart(\/|$|\?|#)/i.test(text))) {
      try { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); } catch(_){}
      (window.top || window).location.href = '/cart';
      return;
    }

    // --- Add-to-cart matchers ---
    // Carousel +-icon button: aria="add <Product> to the cart"
    var ariaAdd = aria.match(/^\s*add\s+(.+?)\s+to\s+(?:the\s+)?cart\s*$/i);
    if (ariaAdd) {
      try { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); } catch(_){}
      addProductToCart(ariaAdd[1]);
      return;
    }
    // Drawer "Add to cart" button: text exact match (or "Adding..." / "Added" post-click states).
    if (/^add\s+to\s+cart$/i.test(text) || /^adding\s+to\s+cart$/i.test(text) || /^added$/i.test(text)) {
      try { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); } catch(_){}
      var prodName = productNameFromDrawer(btn);
      if (prodName) addProductToCart(prodName);
      return;
    }
  }
  function patchDoc(doc){
    if (!doc || doc.__plPatched) return;
    try {
      doc.__plPatched = true;
      doc.addEventListener('click', handleClick, true);
    } catch(e){}
  }
  // Only attach inside Gorgias's iframes. Earlier versions also listened on
  // the parent document, which intercepted the SPA's own catalogue
  // "Add to cart" button and broke its fly-to-cart + drawer-open behavior.
  function scan(){
    var c = document.querySelector('#gorgias-chat-container');
    if (!c) return;
    Array.from(c.querySelectorAll('iframe')).forEach(function(f){
      try { patchDoc(f.contentDocument); } catch(e){}
    });
  }
  scan();
  // Re-scan periodically — Gorgias may add/remove iframes when chat opens/closes
  setInterval(scan, 1500);
  if (document.body) {
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function(){
      new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
      scan();
    });
  }
})();
